<template>
  <div>
    <div @click.once="$emit('onClick', question)" class="pl-0 text-center mt-5 pt-5">
      <div
        class="instruction_title text-left mt-5 pt-5"
        v-translate:dynamic_string="{
          key: `${translationKeyInitial}_formattedTitle`,
          val: lang,
          html: question.formattedTitle
        }"
        v-html="question.formattedTitle"
      ></div>
      <div v-if="question.imageUrl" class="imageBox">
        <img class="img-size" :src="question.imageUrl" />
      </div>
      <div
        class="instruction_info text-left mt-5 pt-5"
        v-translate:dynamic_string="{
          key: `${translationKeyInitial}_formattedInformation`,
          val: lang,
          html: question.formattedInformation
        }"
        v-html="question.formattedInformation"
      ></div>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "image-capture",
  mixins: [langTranslate],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"]
};
</script>
